export default [
  { title: 'Sobre nós', to: '#!' },
  { title: 'Contato', to: '#!' },
  { title: 'Política de privacidade', to: '#!' }
];
